import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable()
export class PasswordService { 
    public data: any = {};
    constructor(private http: Http, private apiService: ApiService) {}

    setPassword(project) {
        return this.apiService.http_post('/setPassword', project);
    }
    
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/password.service.ts